export const SET_SETTLEMENTS = 'SET_SETTLEMENTS'
export const ADD_SETTLEMENT = 'ADD_SETTLEMENT'

export const SET_SELECTED_SETTLEMENTS = 'SET_SELECTED_SETTLEMENTS'
export const SET_TOTAL_SETTLEMENTS = 'SET_TOTAL_SETTLEMENTS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'

